'use strict'
/**
 * Do nothing in the browser.
 */
module.exports = function noop () {}
